module.exports = __webpack_public_path__ + "img/scb.91f6e7ae.png";